/**
 * External dependencies
 */
import { get, omit } from "lodash";

/**
 * Internal
 */
import { createReducer, appendToEditsLog } from "state/utils";
import * as actions from "state/action-types";

export default createReducer(
  {},
  {
    [actions.EDIT_REPORT]: (state, action) => {
      const id = get(action, ["payload", "id"]);
      const report = get(action, ["payload", "report"]) || "";
      const newEditLogs = appendToEditsLog(get(state, id), report);
      return {
        ...state,
        [id]: newEditLogs,
      };
    },
    [actions.REPORT_BUILDER_STOP]: (state, action) => {
      return {};
    },
    [actions.DELETE_REPORT_SUCCESS]: (state, action) => {
      const reportId = get(action, ["payload", ["reportId"]]);
      return omit(state, reportId);
    },
  }
);
